/**
 * Brand wordmark for the zfs-ui shell (sidebar brand row, topbar breadcrumb).
 * NOTE(plan): single source of truth for the product name — change here to rebrand.
 * Not translated on purpose: it is a brand name, not a UI string.
 */
export const zfsBrandWordmark = 'Schematix';
